import styled, { css } from '@styled'

export const DropdownItemWrap = styled.li`
  position: relative;
  line-height: 1;
  cursor: default;
  ${(props) =>
    props.active &&
    css`
      padding: 0 5px;
      &:after {
        position: absolute;
        content: '';
        left: 0;
        bottom: -50px;
        width: 100%;
        height: 50px;
      }
      cursor: pointer;
    `}

  &:hover, &.touch {
    & > ul {
      opacity: 1;
      visibility: visible;
      transform: translateY(10px);
    }
  }
`
